import React from 'react'
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer' 
import Nav from '../../components/Nav/Nav'
import Button from '../../components/Button/Button'
import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';
 


export default class SubmitExpense extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.fileInputRef=React.createRef();
        this.state={
            fileError:'',
            isDragging:false,
        }
    }
    
    componentDidMount=()=>{
        const parentHeight = this.parentRef.current.clientHeight;
        this.setState({ view_height:parentHeight });
    }
    /**
     * handles when the user drags a file over the submission box
     * @param {event} event 
     */
    handleDragOver=(event)=>{
        event.preventDefault()
        this.setState({isDragging:true})
    }
    /**
     * handles when the user drags a file over the submission box
     * @param {event} event 
     */
    handleDragEnter=(event)=>{
        event.preventDefault()
        this.setState({isDragging:true})
    }
    /**
     * handles when the user drags a file out of the submission box
     * @param {event} event 
     */
    handleDragLeave=(event)=>{
        event.preventDefault()
        this.setState({isDragging:false})
    }
    /**
     * handles when the user drops a file in the submission box
     * @param {event} event 
     */
    handleDrop=(event)=>{
        event.preventDefault()
        this.setState({isDragging:false})
        //sets target files in state. Does NOT check file type YET
        //alert(event.target.file)
        console.log(event.dataTransfer.files)
        this.setState({targetFile:event.dataTransfer.files})
        this.checkFileError(event.dataTransfer.files)
    }

    /**
     * isPDFByType
     * 
     * @param {file} file 
     * @returns boolean
     * 
     * isPDFByType takes a file object as input and returns true or false
     * based on whether or not the file is of type 'application/pdf'. this
     * method prevents spoofing file extensions.
     */
    isPDFByType = (file) => {
        return file.type === 'application/pdf';
    };

    isImageByType=(file)=>{

        return file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
    }

    checkFileError=(files)=>{
        //alert(files.length)
        for(let i=0;i<files.length;i++){
            console.log(files[i])
            if(!this.isPDFByType(files[i]) && !this.isImageByType(files[i])){
                this.setState({fileError:'Files must be of PDF, JPEG, JPG, or PNG format. No Other files are allowed'})
                return true
            }
        }
        //set error to empty and submit to backend
        this.setState({fileError:''})
        return false
    }

    submitFile=()=>{
        //load files from state
        const files=this.state.targetFile
        //alert(files)
        //if no files have selected, set error and return
        if(!files){
            this.setState({fileError:'You must select a file before submitting'})
            return
        }
        if(this.state.fileError!=="")
            return
        //if any files are not pdf, set error and return
        if(this.checkFileError(files))
            return
        alert(this.state.targetFile[0].name)
    }
    

    render(){
        const {isDragging}=this.state
        return <div ref={this.parentRef} style={{display:'flex',height:"auto", width:'auto',flexDirection:'column', backgroundColor:Colors.light_grey,overflowX:'hidden'}}>
            <Header authed={true} navigator={this.props.navigator}/>
            <div style={{ display:'flex', flexDirection:'row', backgroundColor:Colors.light_grey}}>
                <div style={{ display:'flex',flex:1,justifyContent:'right',alignItems:'right'}}>
                    <Nav navigator={this.props.navigator} page='submitExpense'/>
                </div>
                <div style={{ display:'flex',flexDirection:'column',flex:3, paddingTop:'2.4vh', paddingLeft:"1vw",paddingRight:'20vw'}}>
                    <div>{/**Title*/}
                        <span style={{...Fonts.title,color:"#003F97"}}><span style={{...Fonts.title,color:'#000'}}>Claims / </span>Submit Expense</span>
                    </div>
                    <div style={{display:'flex',flexDirection:'column',background:"#FFF",width:"47vw",height:'66vh', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:'2.3vh',paddingLeft:'2.3vh',paddingRight:'2.3vh',paddingTop:'2vh'}}>{/**white view */}
                        <span style={{...Fonts.title}}>Receipt Upload</span>
                        <div style={{height:'2vh'}}/>
                        <span style={{...Fonts.text}}>You can submit your receipts by dragging the file into the submission box below, or by selecting a file using the "choose file" button. All files must be in <span style={{fontWeight:600}}>PDF format.</span></span>
                        <div style={{height:'2vh'}}/>
                        <div style={{display:'flex',width:'auto',justifyContent:'center'}}>
                            <div style={{display:'flex',width:'40vw',height:'35vh',border:isDragging?'1px solid '+Colors.light_blue:'1px solid '+Colors.dark_grey,borderRadius:5,justifyContent:'center',alignItems:'center', flexDirection:'column'}}
                                onDragOver={this.handleDragOver}
                                onDragEnter={this.handleDragEnter}
                                onDragLeave={this.handleDragLeave}
                                onDrop={this.handleDrop}
                            >
                                <span style={{...Fonts.text}}>Drag Files Into Here, or <span style={{color:Colors.light_blue, cursor:'pointer'}} onClick={()=>this.fileInputRef.current.click()}>Choose File</span></span>
                                <span style={{...Fonts.error}}>{this.state.fileError}</span>
                                {this.state.targetFile && this.state.targetFile[0] && (
                                    <span style={{...Fonts.text, color: Colors.green}}>{this.state.targetFile[0].name}</span>
                                )}
                            </div>
                        </div>
                        {/* Hidden Input Component, Activated using Ref passed to span for 'Choose File' */}
                        <input style={{display:'none'}} ref={this.fileInputRef} type='file' onChange={(event)=>{this.setState({targetFile:event.target.files});this.checkFileError(event.target.files)}} />
                        
                        <div style={{height:'2vh'}}/>
                        <div style={{display:'flex',justifyContent:'center'}}>
                            <div style={{width:'10vw', height:'2vh'}}>
                                <Button title='submit upload' height='3.5vh' onClick={this.submitFile} />
                            </div>
                        </div>
                    </div>
                    <div style={{display:'flex',height:'9vh', background:Colors.light_grey,}}></div>
                </div>
                
            </div>
            
            <Footer/>
        </div>
    }
}